import React, { Suspense, lazy } from 'react'

const componentMap: Record<
  string,
  React.LazyExoticComponent<React.ComponentType<any>>
> = {
  ResultFeedback: lazy(() => import('./ResultFeedback')),
  MenuHeaderSimpleOTTBlock: lazy(() => import('./MenuHeaderSimpleOTTBlock')),
  FooterSimpleOTTBlock: lazy(() => import('./FooterSimpleOTTBlock')),
  ResultFeedbackMonorepo: lazy(() => import('./ResultFeedbackMonorepo')),
  TitleTest: lazy(() => import('./TitleTest')),
  UserAccountForm: lazy(
    () => import('views/helios/UserAccountView/UserAccountFormView')
  ),
  UserPaymentForm: lazy(
    () => import('views/helios/UserPaymentView/UserPaymentFormView')
  ),
  MenuHeaderTranslucentOTT: lazy(() => import('./MenuHeaderTranslucentOTT')),
  BannerHeroCarousel: lazy(() => import('./BannerHeroCarousel')),
  BannerStreamingInfoPoster: lazy(() => import('./BannerStreamingInfoPoster')),
  BannerStreamingInfoContent: lazy(
    () => import('./BannerStreamingInfoContent')
  ),
  BannerSectionDevices: lazy(() => import('./BannerSectionDevices')),
  FaqQuickAccordion: lazy(() => import('./FaqQuickAccordion')),
  BannerHighlightHard: lazy(() => import('./BannerHighlightHard')),
  BannerPremium: lazy(() => import('./BannerPremium')),
  CardProductSubscriptionCarousel: lazy(
    () => import('./CardProductSubscriptionCarousel')
  ),
  CheckoutCreateAccount: lazy(
    () => import('./CheckoutCreateAccount/CheckoutCreateAccount')
  ),
  MenuHeaderOTT: lazy(() => import('./MenuHeaderOTT')),
  MenuHeaderSimpleOTT: lazy(() => import('./MenuHeaderSimpleOTT')),
  MenuLoggedInOTT: lazy(() => import('./MenuLoggedInOTT')),
  FooterSimpleOTT: lazy(() => import('./FooterSimpleOTT')),
  ExtrasView: lazy(() => import('views/buyflow/ExtrasView')),
  PaymentDataView: lazy(
    () => import('views/buyflow/PaymentDataView/PaymentDataView')
  ),
  PaymentMethodView: lazy(
    () => import('views/buyflow/PaymentMethodView/PaymentMethodView')
  ),
  CheckoutPaymentMethodPixView: lazy(
    () =>
      import(
        'views/buyflow/CheckoutPaymentMethodPixView/CheckoutPaymentMethodPixView'
      )
  ),
  CheckoutResumeTexts: lazy(() => import('./CheckoutResumeTexts')),
  Spacer: lazy(() => import('./Spacer')),
  FooterSpacer: lazy(() => import('./FooterSpacer')),
  FooterOtt: lazy(() => import('./FooterOtt')),
  StepTitle: lazy(() => import('./StepTitle')),
  PopoverPremium: lazy(() => import('./PopoverPremium')),
  PopoverPlan: lazy(() => import('./PopoverPlan')),
  ModalIllustrativeIconRegister: lazy(
    () => import('./ModalIllustrativeIconRegister')
  ),
  ModalGeoContext: lazy(() => import('./ModalGeoContext')),
  ModalGeoContextProps: lazy(
    () => import('./ModalGeoContext/ModalGeoContextProps')
  ),
  ModalAbandonedCart: lazy(() => import('./ModalAbandonedCart')),
  ModalAbandonedCartProps: lazy(
    () => import('./ModalAbandonedCart/ModalAbandonedCartProps')
  ),
  CookieConsentBanner: lazy(() => import('./CookieConsentBanner')),
  CookieConsentBannerProps: lazy(
    () => import('./CookieConsentBanner/CookieConsentBannerProps')
  ),
  CheckoutPersonalInformation: lazy(
    () => import('./CheckoutPersonalInformation/CheckoutPersonalInformation')
  ),
  Toast: lazy(() => import('./Toast/Toast')),
  CheckoutAddress: lazy(() => import('./CheckoutAddress')),
  CheckoutGroupCardFlagProps: lazy(
    () => import('./CheckoutGroupCardFlagProps')
  ),
  CheckoutGiftCard: lazy(() => import('./CheckoutGiftCard/CheckoutGiftCard')),
  PopoverPaymentCode: lazy(
    () => import('./PopoverPaymentCode/PopoverPaymentCode')
  ),
  WelcomeView: lazy(() => import('views/buyflow/WelcomeView/WelcomeView')),
  Thumbnails: lazy(() => import('./Thumbnails/Thumbnails')),
  OtpView: lazy(() => import('views/buyflow/OtpView')),
  PaymentInProgressView: lazy(
    () => import('views/buyflow/PaymentInProgressView')
  ),
  SubscriptionView: lazy(() => import('views/selfcare/SubscriptionView')),
  ErrorView: lazy(() => import('views/buyflow/ErrorView'))
}

function Components(
  reactComponent: string,
  hashPage: string,
  hashObjects: string,
  liferayFields: any
) {
  if (!reactComponent) {
    return (
      <>
        <h3 className="text-color-warning-text">ERRO AO RENDERIZAR CONTEÚDO</h3>
        <b className="text-color-warning-text-weak">
          Para renderizar corretamente o componente obrigatóriamente precisa
          conter o campo: <i>reactComponent</i> na estrutura devidamente
          registrado e o conteúdo preenchido, por favor verifique os respectivos
          dados e tente novamente
        </b>
        <br />
      </>
    )
  }

  if (reactComponent === 'Vazio') {
    return <></>
  }

  const LazyComponent = componentMap[reactComponent]

  if (!LazyComponent) {
    return (
      <>
        <div className="hidden">
          Não foi encontrado registros do reactComponent recebido{' '}
        </div>
      </>
    )
  }

  return (
    <Suspense fallback={null}>
      <LazyComponent liferayFields={liferayFields} />
    </Suspense>
  )
}

export default Components
